import { axiosInstance } from '@/rest'

const toSnakeCase = (obj) => {
  if (Array.isArray(obj)) return obj.map(toSnakeCase)
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [
        k.replace(/([A-Z])/g, '_$1').toLowerCase(),
        toSnakeCase(v),
      ])
    )
  }
  return obj
}

const createOrderApi = () => {
  return {
    validate_v2: (body) =>
      axiosInstance.post('v2/order_validator/validate', toSnakeCase(body)),

    debitCredit: (body) =>
      axiosInstance.post('order_validator/debit_credit', body),

    submit_v2: (orderId) =>
      axiosInstance.post(`v2/order_validator/${orderId}/submit-new`),

    cancel_v2: (orderId) =>
      axiosInstance.post(`v2/order_validator/${orderId}/cancel`),

    modify_v2: (orderId, body) =>
      axiosInstance.post(`v2/order_validator/${orderId}/modify`, body),

    submitModify: (orderId) =>
      axiosInstance.post(`v2/order_validator/${orderId}/submit-modify`),
  }
}

const orderApi = createOrderApi()

export { orderApi }
